import addItemsReducer from './addItemsSlice';
import dlItemsReducer from './dlItemsSlice';
import schemaConfigReducer from './schemaConfigSlice';

const root = {
	addItems: addItemsReducer,
	dlItems: dlItemsReducer,
	schemaConfig: schemaConfigReducer
};

export default root;
